import {Component, OnInit} from '@angular/core';
import {AsyncPipe, CommonModule, NgClass, NgForOf, NgIf} from "@angular/common";
import {BaseSectionComponent} from "../base-section/base-section.component";
import {TinyPostComponent} from "../../elements/tiny-post/tiny-post.component";
import {TinyPostsFromIdsPipe} from "../../../pipes/tinyPostFromId/tiny-post-from-id.pipe";
import {PageFreeSection} from "../../../models/Page/Sections/PageFreeSection";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";

@Component({
  selector: 'free-section',
  standalone: true,
  imports: [
    AsyncPipe,
    BaseSectionComponent,
    CommonModule,
    TinyPostComponent,
    TinyPostsFromIdsPipe,
    SafeHtmlPipe,
  ],
  templateUrl: './free-section.component.html',
  styleUrl: './free-section.component.scss'
})
export class FreeSectionComponent extends BaseSectionComponent<PageFreeSection> implements OnInit{

}
